import { render, staticRenderFns } from "./DeliveryRouteDetailsPage.vue?vue&type=template&id=9b4ea2da"
import script from "./DeliveryRouteDetailsPage.vue?vue&type=script&lang=js"
export * from "./DeliveryRouteDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports